<template lang="pug">
  .dashboard-inner.narrow-modal-body
    SectionTitle(text="Verify your address").app-modal-title

    p.message(v-if="validatedAddress.street_1") To ensure prompt and accurate delivery, the USPS suggests a slightly modified address.
    p.message(v-else)
      | Please double check your information. Your address is not USPS-validated, which might result in delivery issues. Give us a call at&nbsp;
      MrPhoneLink(:number="$root.MRConfig.contactPhone")
      | &nbsp;if you have any questions.

    .row(v-if="validatedAddress.street_1")
      .choice.xs-12
        .mr-radio(:class="{ 'selected': validatedAddress == selectedAddress } ")
          input(type="radio" v-model="selectedAddress" :value="validatedAddress")
        p.semi-bold.xs-f-small.max-at-tweak.checkbox-label Suggested Address:
        Address(:address="validatedAddress")

    .row
      .choice.xs-12
        .mr-radio(v-if="validatedAddress.street_1" :class="{ 'selected': editAddressForm == selectedAddress } ")
          input(type="radio" v-model="selectedAddress" :value="editAddressForm")
        p.semi-bold.xs-f-small.max-at-tweak.checkbox-label Original Address:
        Address(:address="editAddressForm")

    .row.mt-15
      SubmitButtons(submit-text="Ship to this address" cancel-text="Cancel" :submit-method="onSubmit" :cancel-method="hideModal")
  
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';
  import Address from './Address';
  import SubmitButtons from "../SubmitButtons";
  import SectionTitle from "../SectionTitle";
  import MrPhoneLink from "../mrPhoneLink";

  export default {
    name: "AddressVerifyModal",
    components: {
      MrPhoneLink,
      SectionTitle,
      SubmitButtons,
      Address
    },

    data() {
      return {
        selectedAddress: {}
      };
    },

    computed: {
      validatedAddress() {
        var validated = this.$store.state.addressBook.validatedAddress;
        this.selectedAddress = validated;
        return validated;
      },

      editAddressForm() {
        return this.$store.state.addressBook.editAddressForm;
      }
    },

    methods: {
      ...mapActions('addressBook', [
        'cancelValidatedAddress',
        'confirmValidatedAddress',
        'clearEditAddressForm'
      ]),

      ...mapActions('modal', ['hideModal']),

      ...mapMutations('addressBook', [
        'setSavingAddress'
      ]),

      onSubmit() {
        // to avoid validation on save if customer chooses notValidated address
        this.$store.commit('addressBook/updateSkipValidation', true);
        this.confirmValidatedAddress(this.selectedAddress);
        this.clearEditAddressForm();
        this.hideModal();
      },

      beforeDestroy() {
        this.cancelValidatedAddress();
        this.setSavingAddress(false);
      }
    }
   }
</script>

<style scoped lang="stylus">
  .message
    padding 1em 0 2em

  .choice
    position relative
    padding-left 2em
    padding-bottom 2em

    .mr-radio
      position absolute
      top 0
      left 0

</style>
